import CodeBox from "../../../../../doc-comps/happy-box";
import BasicDemo from "../../../../../components/tooltip/demo/basic";
import BasicDemoCode from "!raw-loader!../../../../../components/tooltip/demo/basic";
import * as React from 'react';
export default {
  CodeBox,
  BasicDemo,
  BasicDemoCode,
  React
};